var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gc-text-field',{attrs:{"value":_vm.showCurrentTime && _vm.currentTime !== undefined && _vm.currentTime.length > 0
      ? _vm.currentTime
      : _vm.value,"type":"time","rules":_vm.rules,"suffix":_vm.$t('timeSuffix')},on:{"input":_vm.onInput,"click:clear":function($event){return _vm.onClear()}}})}
var staticRenderFns = []

export { render, staticRenderFns }